/**
 * useSendSupportRequest
 *
 * React Query mutation hook for sending support requests.
 * Handles success / error toasts automatically.
 */

import { useMutation } from '@tanstack/react-query';
import { useClinicContext } from '@/hooks/main/useClinicContext';
import { useTheme } from '@shared/providers/theme/ThemeContext';
import { SERVICE_TYPE_A2, SERVICE_TYPE_R2 } from '@/constants/serviceType';
import { sendSupportRequest } from '@/services/main/support';
import { getApiErrorMessage } from '@/utils/apiError';
import useAppToast from '@/hooks/useAppToast';
import type { SupportRequestFormData } from '@/schemas/supportRequestSchema';

export const useSendSupportRequest = () => {
  const { tenant, clinicNumber } = useClinicContext();
  const { serviceType } = useTheme();
  const toast = useAppToast();

  return useMutation({
    mutationFn: (data: SupportRequestFormData) => {
      const resolvedService =
        serviceType === SERVICE_TYPE_R2 ? SERVICE_TYPE_R2 : SERVICE_TYPE_A2;
      return sendSupportRequest(tenant, clinicNumber, data, resolvedService);
    },
    onError: error => {
      const msg = getApiErrorMessage(error, '送信ができませんでした。');
      toast.error(msg);
    },
  });
};
